import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPageCircles = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "260px",
	height: "300px",
	viewBox: "0 0 260 300",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		opacity: .30048334,
		children: /* @__PURE__ */ _jsx("g", {
			transform: "translate(-1123.000000, -560.000000)",
			children: /* @__PURE__ */ _jsxs("g", {
				transform: "translate(1123.000000, 560.000000)",
				children: [
					/* @__PURE__ */ _jsx("circle", {
						fill: "#009EE3",
						cx: 72,
						cy: 228,
						r: 72
					}),
					/* @__PURE__ */ _jsx("circle", {
						fill: "#F8B477",
						cx: 144.5,
						cy: 107.5,
						r: 48.5
					}),
					/* @__PURE__ */ _jsx("circle", {
						fill: "#E5007D",
						cx: 90,
						cy: 18,
						r: 18
					}),
					/* @__PURE__ */ _jsx("circle", {
						fill: "#009FAC",
						cx: 221.5,
						cy: 28.5,
						r: 9.5
					}),
					/* @__PURE__ */ _jsx("circle", {
						fill: "#E2E2E2",
						cx: 65.5,
						cy: 115.5,
						r: 12.5
					}),
					/* @__PURE__ */ _jsx("circle", {
						fill: "#E2E2E2",
						cx: 247.5,
						cy: 94.5,
						r: 12.5
					}),
					/* @__PURE__ */ _jsx("circle", {
						fill: "#FFED00",
						cx: 28.5,
						cy: 45.5,
						r: 9.5
					})
				]
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgPageCircles);
export { ForwardRef as ReactComponent };
